export class CommonConstants {

    public static readonly ROUTES = {
        CATALOG: '/catalog' as const,
        SERVICE_MATRIX: '/service-matrix' as const,
    }
    public static readonly CATALOG = "catalog" as const;
    public static readonly SERVICE_MATRIX = "service-matrix" as const;
}